import { render, staticRenderFns } from "./collectionConfiguration.vue?vue&type=template&id=09592929"
import script from "./collectionConfiguration.vue?vue&type=script&lang=js"
export * from "./collectionConfiguration.vue?vue&type=script&lang=js"
import style0 from "./collectionConfiguration.vue?vue&type=style&index=0&id=09592929&prod&lang=css"
import style1 from "./collectionConfiguration.vue?vue&type=style&index=1&id=09592929&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports